import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/fontawesome-pro-regular'

const SubmitButton = ({
  text = 'Submit',
  icon = faSpinnerThird,
  loading = false,
  disabled = false,
  testKey,
  onClick = null,
  inputRef = null,
  className = 'btn btn--main-confirm margin-top-2',
}) => {
  const buttonText = loading ? (
    <FontAwesomeIcon icon={faSpinnerThird} spin />
  ) : (
    text
  )

  const type = onClick ? '' : 'submit'

  return (
    <button
      id={`ext--${testKey}`}
      data-test-key={testKey}
      type={type}
      className={className}
      disabled={disabled}
      onClick={onClick}
      ref={inputRef}
    >
      {buttonText}
    </button>
  )
}

export default SubmitButton
